import { render, staticRenderFns } from "./HotelInfoTheme1.vue?vue&type=template&id=701a2abc&scoped=true"
import script from "./HotelInfoTheme1.vue?vue&type=script&lang=js"
export * from "./HotelInfoTheme1.vue?vue&type=script&lang=js"
import style0 from "./HotelInfoTheme1.vue?vue&type=style&index=0&id=701a2abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a2abc",
  null
  
)

export default component.exports